<template>
  <v-app>
    <router-view />

    <!-- Global Dialogs -->
    <DialogContainer />

    <!-- Global Snackbars -->
    <SnackbarContainer />

    <!-- User Profile Completion Dialog -->
    <UserProfileCompletionDialog v-model="authStore.showProfileCompletionDialog" />

    <!-- Global Notifications -->
    <div class="notification-container">
      <v-snackbar
        v-for="notification in notificationStore.notifications"
        :key="notification.id"
        v-model="notification.show"
        :color="notification.type"
        :timeout="notification.persistent ? -1 : notification.timeout"
        :location="notifications.length > 1 ? 'top center' : 'bottom center'"
        :style="notifications.length > 1 ? { position: 'relative', marginBottom: '8px' } : {}"
      >
        {{ notification.message }}
        <template #actions>
          <v-btn
            variant="text"
            @click="notificationStore.hideNotification(notification.id)"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script setup>
import { useAuthStore } from './stores/authStore'
import { useNotificationStore } from './stores/notificationStore'
import DialogContainer from './layouts/default/DialogContainer.vue'
import SnackbarContainer from './layouts/default/SnackbarContainer.vue'
import UserProfileCompletionDialog from './components/UserProfileCompletionDialog.vue'

const authStore = useAuthStore()
const notificationStore = useNotificationStore()
const { notifications } = notificationStore
</script>

<style>
/* Global styles for table links */
.v-table a {
  color: #1976d2;
  text-decoration: none;
  transition: color 0.2s;
}

.v-table a:hover {
  color: #1565c0;
  text-decoration: underline;
}
</style>
